<template>
   <RenderEvent event="page" :only="this.$route.params.id"/>
</template>

<script>
import RenderEvent from '../../components/integrations/RenderEvent.vue'
export default {
    components: {
        RenderEvent
    }
}
</script>